module.exports = __webpack_public_path__ + "img/IND-i-2-II.f3be4965.png";